export default function(minScreenWidth = 1400) {
  const screenWidth = window.document.body.offsetWidth;
  return screenWidth < minScreenWidth;
}
